// extracted by mini-css-extract-plugin
export default {"menu":"ActionsPopup_menu__soJVa","menuItem":"ActionsPopup_menuItem__lFURP","meta":"ActionsPopup_meta__K0SsB"};